/**
 * @generated SignedSource<<c61bc10200a995ca81675126806924c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useCoreBuyerIncentives_user$data = {
  readonly tradeFirm?: {
    readonly rewards: {
      readonly currentProgram: {
        readonly childPrograms: ReadonlyArray<{
          readonly code: string | null;
        } | null> | null;
        readonly programInfo: {
          readonly code: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
  readonly " $fragmentType": "useCoreBuyerIncentives_user";
};
export type useCoreBuyerIncentives_user$key = {
  readonly " $data"?: useCoreBuyerIncentives_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCoreBuyerIncentives_user">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isTrade"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useCoreBuyerIncentives_user",
  "selections": [
    {
      "condition": "isTrade",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TradeFirmType",
          "kind": "LinkedField",
          "name": "tradeFirm",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TradeFirmRewards",
              "kind": "LinkedField",
              "name": "rewards",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ParentProgram",
                  "kind": "LinkedField",
                  "name": "currentProgram",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LoyaltyProgram",
                      "kind": "LinkedField",
                      "name": "programInfo",
                      "plural": false,
                      "selections": (v0/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "filter",
                          "value": "ENHANCED_BUYER_PROTECTION"
                        }
                      ],
                      "concreteType": "LoyaltyProgram",
                      "kind": "LinkedField",
                      "name": "childPrograms",
                      "plural": true,
                      "selections": (v0/*: any*/),
                      "storageKey": "childPrograms(filter:\"ENHANCED_BUYER_PROTECTION\")"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "34dfbfe8bcd5b0ca70a4701c6260e593";

export default node;
